export default __webpack_public_path__ + "static/media/nflStaff3.f87d55c4.jpg";